function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawCryptoFlowers = function UndrawCryptoFlowers(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 973.3 761.25",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 572.47,
    y1: 806.15,
    x2: 572.47,
    y2: 69.38,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), React.createElement("linearGradient", {
    id: "prefix__b",
    x1: 1361.31,
    y1: 830.62,
    x2: 1361.31,
    y2: 437.76,
    gradientTransform: "matrix(-1 0 0 1 1614 0)",
    xlinkHref: "#prefix__a"
  })), React.createElement("path", {
    d: "M917.26 480.46c-33 42-20.21 103.4.79 152.55 7 16.46 15 33.87 12 51.52-3.63 21.58-22.89 37.37-43.12 45.73-36.87 15.25-81 11.61-114.86-9.46-29.28-18.21-50.24-47.83-80-65.21-49.83-29.09-113.25-18.11-167.36 1.93-38.28 14.18-80.13 32.61-118.17 17.8-26.77-10.43-45.27-35.8-55.35-62.7-4.87-13-8.4-27-17.69-37.34-5.53-6.12-12.74-10.46-20.12-14.13-67.45-33.43-152.64-15.53-218.16-52.62-44.25-25.05-72.57-72.31-85.12-121.58S-.98 286.01 2.2 235.26c2.26-36.06 6.32-74.56 29.37-102.4 24.38-29.44 66.21-40.39 104-34.8s72.08 25.56 102.27 49.04c37.69 29.36 72.63 65.92 118.9 77.82 31.51 8.1 64.66 3.67 97.15 2.13 54.33-2.57 108.68 3.14 162.71 9.39 51.72 6 103.82 12.56 153.1 29.39 34.87 11.91 62.83 33.52 95.75 48.62 21.46 9.84 44.87 12.56 65.19 25.1 25 15.44 48 42.3 41.57 73.74-6.1 29.88-37.41 44.87-54.95 67.17z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M877.9 698.75a77.61 77.61 0 0 0-13.28-12.34q1.53-1.11 3-2.23c12.62-9.38 23.43-19 25.75-25.91 6.2-18.33 69.77-51.93 69.77-51.93s-65.12 12.22-99.23-7.64c-20.35-11.85-51.74-13.91-73.75-13.64l.16-.38.3-.66c.17-.37.34-.73.52-1.1s.29-.6.45-.9l.13-.24c.23-.44.47-.88.72-1.32.61-1.08 1.26-2.16 1.95-3.24v-.06a87.18 87.18 0 0 1 5.77-7.88l.08-.1c1.65-2 3.37-4 5.1-5.83l.1-.11 1.22-1.29.2-.2c1.65-1.73 3.3-3.37 4.9-4.9l.37-.35 1-.91.46-.43.89-.83.47-.43 1.33-1.2.72-.64.54-.47.79-.69.4-.34 1-.88.09-.08c3.23-2.76 5.36-4.37 5.36-4.37h-.05a29.41 29.41 0 0 1-3.21 2l-.15.07-1 .5-.28.13-.89.4-.5.2-.7.29-.68.25-.55.2-.86.29-.4.13-1.1.33-.18.05-1.3.35c-22.62 5.83-54.77-2.79-57.72-3.61l-.19-.05s-12.92-2.67-29.66-5.07a1199.15 1199.15 0 0 1 22.73-44.12 67.45 67.45 0 0 0 30 31.7c.5-.56 1-1.14 1.42-1.72 1.5.86 2.39 1.27 2.39 1.27a38 38 0 0 0 8.5-16.82 62.43 62.43 0 0 0 14.45 10.24q.65-.73 1.25-1.49c.61.32.94.48.94.48 8.37-9.43 10.59-21.61 9.65-34a68.74 68.74 0 0 0 48.35.21v-.19c1.44-.49 2.23-.83 2.23-.83-1.26-9.27-6-17-12.44-23.42 29.88.62 46-17.9 46-17.9l-.17-.23c1.23-1.15 1.85-1.86 1.85-1.86a53.17 53.17 0 0 0-14.68-14c13.64-8.07 19.55-18.52 19.55-18.52-.34-.32-.7-.63-1-.94.75-1.08 1.12-1.73 1.12-1.73-.75-.71-1.53-1.38-2.31-2 .51-.77.76-1.21.76-1.21-12-11.29-27.92-15.36-43.71-15.83a66.39 66.39 0 0 0 16.75-38.2c-12-3.91-24.26-1.21-35.42 4.41a67.55 67.55 0 0 0-4.38-30.52 56.48 56.48 0 0 0 9.83 6.08q.64-.74 1.23-1.51c.61.31 1 .46 1 .46 8.22-9.56 10.24-21.77 9.11-34.1a68.74 68.74 0 0 0 48.35-.54v-.19c1.43-.51 2.21-.86 2.21-.86-1.41-9.25-6.23-16.91-12.81-23.23 29.88.16 45.71-18.61 45.71-18.61l-.18-.23c1.21-1.17 1.82-1.89 1.82-1.89a53.21 53.21 0 0 0-14.9-13.72c13.51-8.28 19.25-18.82 19.25-18.82-.35-.32-.71-.62-1.06-.93.73-1.1 1.09-1.75 1.09-1.75-.76-.7-1.55-1.36-2.34-2 .5-.78.75-1.22.75-1.22-12.17-11.1-28.16-14.93-44-15.15a66.36 66.36 0 0 0 16.13-38.45c-12.1-3.73-24.27-.83-35.34 5a65.87 65.87 0 0 0-6-32.87c-.82.17-1.62.37-2.41.58-.19-.4-.3-.6-.3-.6-.32-.7-.52-1.08-.52-1.08-13.73 2.77-23.58 12.66-30.58 24.54-.52.88-1 1.77-1.51 2.67a67.29 67.29 0 0 0-25.9-31.28c-10.23 9.65-13.18 23.37-12.62 37.25 0 .94.1 1.88.16 2.82a68.65 68.65 0 0 0-40.92-14.54c-2.11 8.24-1.11 16.35 1.79 24a68.09 68.09 0 0 0-29.95 2.09v.39c-1.43.38-2.22.66-2.22.66.78 11.62 7 21.23 15.57 29a68.32 68.32 0 0 0-35.43 16.57q.5.88 1 1.71c-.7.61-1.06 1-1.06 1 6.11 10.79 16.8 16.93 28.73 20.26A67.14 67.14 0 0 0 716 277.13c.29.2.58.39.87.59-.61 1.32-.89 2.09-.89 2.09 10.19 7.26 22.55 8.37 34.82 6.4a68.17 68.17 0 0 0-2.46 21.71c-7.53 10.57-15.17 21.63-22.71 32.82-1.36-.08-2.12-.07-2.12-.07a36 36 0 0 0-.93 4.61c-4.16 6.2-8.28 12.42-12.33 18.59a61.41 61.41 0 0 0-15.25 2.47v.39c-1.43.36-2.23.62-2.23.62v.48c-6.7-9.05-16.08-15.82-26.19-20.87a67.53 67.53 0 0 0 31.64-27.56c-9.21-8.58-21.44-11.25-34-10.83a65.91 65.91 0 0 0 9.28-32.12c-.81-.21-1.62-.37-2.43-.52v-.67-1.19c-13.57-3.46-26.82 1.17-38.42 8.81-.86.57-1.71 1.15-2.55 1.75a66.22 66.22 0 0 0-9.32-39.31c-13.5 4.25-22.26 15.29-27.94 28-.39.86-.75 1.73-1.11 2.61a67.52 67.52 0 0 0-30.28-30.77c-5.57 6.49-8.28 14.21-9.1 22.35a67.77 67.77 0 0 0-27.84-11.08l-.14.37c-1.45-.28-2.29-.37-2.29-.37-4.48 10.78-3.14 22.12 1 32.81a69 69 0 0 0-39.08-.44c0 .67.09 1.33.17 2-.9.25-1.38.41-1.38.41.68 12.34 7.54 22.48 16.78 30.63A68.39 68.39 0 0 0 461.23 338c.17.31.35.6.52.9-1.13.92-1.73 1.49-1.73 1.49 5.92 10.93 16.53 17.28 28.42 20.82a65.94 65.94 0 0 0-14.73 26.46c.9.48 1.8.91 2.72 1.32-.2.69-.29 1.08-.29 1.08 12.75 6.89 27.34 5.26 40.9.26-4.11 28.47 12.82 48.56 12.82 48.56.69-.3 1.37-.62 2-1 1 1.4 1.61 2.15 1.61 2.15a38.68 38.68 0 0 0 15-11.67 61.27 61.27 0 0 0 8.67 15.32q.91-.39 1.78-.83c.41.54.65.83.65.83a38.66 38.66 0 0 0 15-11.62c1.33 29.16 2.47 77.26-.83 126.87-2 30.28-5.67 61.13-12 88.59-11.47-47.45-26.26-104.93-41.23-152.74-16.32-52.13-47.76-101.91-76.93-148.28-20.81-33.07-47.17-73.64-71.89-107.83 22.94 7.62 41-.38 41-.38s0-.19-.06-.28c1.61-.52 2.48-.91 2.48-.91a52.26 52.26 0 0 0-7.27-18.78c15.83-1.59 25.69-8.58 25.69-8.58-.17-.44-.36-.86-.54-1.29 1.15-.67 1.76-1.1 1.76-1.1-.38-1-.79-1.89-1.22-2.81.8-.48 1.22-.78 1.22-.78-6-15.24-18.65-25.6-32.74-32.63a67.53 67.53 0 0 0 31.64-27.56c-9.21-8.58-21.44-11.25-34-10.83a65.91 65.91 0 0 0 9.35-32.08c-.81-.21-1.62-.37-2.43-.52v-.67-1.19c-13.57-3.46-26.82 1.17-38.42 8.81-.86.57-1.71 1.15-2.55 1.75a66.22 66.22 0 0 0-9.32-39.31c-13.5 4.25-22.26 15.29-27.94 28-.39.86-.75 1.73-1.11 2.61a67.52 67.52 0 0 0-30.28-30.77c-5.57 6.49-8.28 14.21-9.1 22.35A67.77 67.77 0 0 0 260 80.65l-.14.37c-1.45-.28-2.29-.37-2.29-.37-4.48 10.78-3.14 22.12 1 32.81a69 69 0 0 0-39.22-.44c0 .67.09 1.33.17 2-.9.25-1.38.41-1.38.41.68 12.34 7.54 22.48 16.78 30.63a68.39 68.39 0 0 0-38.32 16.19c.17.31.35.6.52.9-1.13.92-1.73 1.49-1.73 1.49 5.92 10.93 16.53 17.28 28.42 20.82a65.94 65.94 0 0 0-14.73 26.46c.9.48 1.8.91 2.72 1.32-.2.69-.29 1.08-.29 1.08 12.75 6.89 27.34 5.26 40.9.26-4.11 28.47 12.82 48.56 12.82 48.56.69-.3 1.37-.62 2-1 1 1.4 1.61 2.15 1.61 2.15a38.68 38.68 0 0 0 15-11.67 61.26 61.26 0 0 0 8.72 15.38q.91-.39 1.78-.83c.41.54.65.83.65.83 11.64-5 18.9-15.12 23.39-26.69 16.33 17.13 37.1 19.92 42.4 20.36 30.4 42.94 67.31 98.74 90.76 146.92 0 0 48.25 93.23 79 190.95-15.63-16.5-37-40.44-41.79-52.71-7.75-19.86-103.88 0-103.88 0l-.19.05c-3 .82-35.1 9.44-57.72 3.61l-1.28-.35-.18-.05-1.1-.33-.4-.13-.86-.29-.55-.2-.68-.25-.7-.29-.5-.2-.89-.4-.28-.13-1-.5-.15-.07a29.41 29.41 0 0 1-3.21-2h-.05a171.25 171.25 0 0 1 24 22.87l.23.28 1.26 1.54.33.41q.62.78 1.22 1.56l.24.31q.69.92 1.36 1.85l.33.48q.47.66.92 1.33l.52.78.67 1 .55.88.56 1c.18.31.37.62.54.93l.07.13c.29.53.58 1.05.85 1.58l.28.57q.35.7.66 1.39l.23.51.18.43c-22-.27-53.4 1.79-73.75 13.64-34.11 19.86-99.23 7.64-99.23 7.64s63.57 33.6 69.77 51.93c2.48 7.32 14.57 17.79 28.23 27.74l2.94 2.12a76.72 76.72 0 0 0-11 10.62c-31 36.66-105.43 73.32-105.43 73.32h.22l.64.06 1.1.1 2 .19h.34c15.92 1.5 72 7.27 104 16.89 1.15.35 2.27.7 3.35 1.05 9.3 3.05 62-1.53 97.68-12.22 1-.3 2-.57 3-.83l.89-.22q1.12-.27 2.25-.51l.89-.19c1-.2 2-.39 3-.55H381c1-.17 2-.31 3-.44l.91-.11 2.19-.24.95-.09q1.36-.12 2.71-.19h.29c1-.05 1.93-.09 2.9-.11H400.01l1.4.05 2 .1 1.43.1 1.24.1 1.59.14.75.08 1.71.18 1.22.15.92.12 1.35.19.75.11c0 .21-.08.44-.12.66 0 0 1.29 7.19 9.75 14.22-14.33 4.12-26.22 8.86-35.1 14-.53.29-1 .6-1.52.9.36 0 .71-.08 1.09-.11s.67 0 1 0H755.1c.33 0 .71.06 1.07.11a8.86 8.86 0 0 1 .88.14 6.28 6.28 0 0 1 .93.2q-1-.64-2-1.24c-11.1-6.48-26.9-12.23-46.25-17 5.81-3 9.05-6.4 10.4-10 1.14-.26 2.3-.51 3.51-.75a132.79 132.79 0 0 1 14.32-2.11l2-.16 1-.08a94.29 94.29 0 0 1 33 3.32c35.66 10.69 88.37 15.27 97.68 12.22 1.08-.36 2.2-.71 3.35-1.05 31.93-9.61 88-15.39 104-16.89h.34l2-.19 1.1-.1.64-.06h.22s-74.38-36.67-105.39-73.33zm-42.75-377.8l-.51.11c0-.16.07-.32.1-.48zM684.26 404.3a68.847 68.847 0 0 0-5.74 3.45 53.47 53.47 0 0 0-6.08-13.59 61.46 61.46 0 0 0 22.56-6.71c-3.71 5.76-7.29 11.39-10.74 16.85zm6.74 28.11a64.67 64.67 0 0 0 9.51 3.6 67.21 67.21 0 0 0-19.76 17.37c3.15-6.93 6.59-13.93 10.25-20.97zM592.2 559c2.82-46.59 4.54-97 2.14-132.49a68.46 68.46 0 0 0 32.31 11l.05-.19c1.51.16 2.37.19 2.37.19 2.85-8.92 1.94-17.88-1.16-26.41a63.71 63.71 0 0 0 44.44 4.69 36.37 36.37 0 0 0 2.38 3.69c-19.35 31-32.52 53.25-32.52 53.25-13.41 20.17-35.51 90.7-55.6 161.54 1.86-21.14 3.92-47.54 5.59-75.27zm59.33-12.22c-3.7 9.48-17.29 25.91-30.49 40.51 17.32-43.61 34.68-80.55 44.37-100.42 2.75-5.63 5.39-11.31 8-17 9.95 7 22 8.21 34 6.48a65.35 65.35 0 0 0-1.92 30.12c1 .06 2 .07 3 .05.12.71.2 1.09.2 1.09a38.1 38.1 0 0 0 13.54-1.61c-5.34 10.82-10.69 22-15.94 33.33-24.98-2.48-50.88-2.47-54.75 7.44zM836 322.62c-.18-.4-.29-.61-.29-.61-.2-.45-.35-.77-.43-.94q.79.7 1.57 1.34zm-69.12-7.27c8.52-2.92 16.07-8.59 22.59-15.37a66.28 66.28 0 0 0 24.29 32.7 66 66 0 0 0-9.51 12.32c-.53.87-1 1.76-1.55 2.65A67.25 67.25 0 0 0 777.3 316c-10.39 9.49-13.55 23.16-13.21 37 0 .94.07 1.88.12 2.83A66.47 66.47 0 0 0 745.28 345c7.39-10.46 14.72-20.42 21.63-29.65z",
    transform: "translate(-113.35 -69.38)",
    fill: "url(#prefix__a)"
  }), React.createElement("path", {
    d: "M435.02 550.67s-49.7-49.7-57.23-69.27-100.9 0-100.9 0-46.68 13.55-67.77-1.51c0 0 33.13 25.6 36.14 46.68s120.48 75.3 120.48 75.3l69.28 64.75 24.1-13.55z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M459.12 653.08l-24.1 13.54-19.37-18.06-49.9-46.68s-117.46-54.26-120.48-75.26a35.63 35.63 0 0 0-4.37-12c-9.5-17.24-30.62-33.81-31.73-34.68 21.1 15 67.72 1.48 67.72 1.48s93.37-19.58 100.9 0 57.23 69.27 57.23 69.27z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M427.49 648.56h-11.84l-49.9-46.68s-117.46-54.26-120.48-75.26a35.63 35.63 0 0 0-4.37-12 263.85 263.85 0 0 1 28.46 1.43c33.13 33.13 79.81 49.7 79.81 49.7 46.7-30.13 78.32 82.81 78.32 82.81z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M425.99 653.08h-57.23l-155.11-6s-23.39-13.6-43.36-28.37c-13.27-9.8-25-20.13-27.42-27.35-6-18.07-67.77-51.2-67.77-51.2s63.25 12 96.38-7.53 96.38-12 96.38-12c33.13 33.13 79.81 49.7 79.81 49.7 25.89-16.7 47.14 10.59 60.95 38.21a285.61 285.61 0 0 1 17.37 44.54zM478.65 550.67s49.7-49.7 57.23-69.27 100.9 0 100.9 0 46.68 13.55 67.77-1.51c0 0-33.13 25.6-36.14 46.68s-120.48 75.3-120.48 75.3l-69.28 64.75-24.1-13.55z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M704.54 479.93c-1.11.87-22.23 17.45-31.73 34.7a35.44 35.44 0 0 0-4.37 12c-3 21.08-120.48 75.3-120.48 75.3l-49.94 46.68-19.37 18.01-24.1-13.55 24.1-102.4s49.7-49.7 57.23-69.27 100.9 0 100.9 0 46.66 13.54 67.76-1.47z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M429.54 634.62c-2.1 1.95-5.63 3.57-5 6.37a4.64 4.64 0 0 0 1.62 2.36c3.92 3.48 10.27 6.19 9.74 11.41-.3 3-2.92 5.13-4.2 7.83-2.67 5.64 1.54 12.83 7.47 14.77s12.57-.34 17.46-4.23c1.05-.84 2.17-1.79 3.51-1.79a9.49 9.49 0 0 1 2.94.91c4 1.38 8.51-1.68 10.22-5.59s1.4-8.37 1.05-12.62c2.27 1.93 6 .88 7.93-1.41s2.49-5.38 3-8.32l3.57-20.61c2.86-.83 4-4.69 2.69-7.36s-4.36-4.13-7.32-4.41-5.92.39-8.84.95a112 112 0 0 1-23.19 2c-6.45-.13-14.73-8.09-18.29-1-3.25 6.34 1.54 15.27-4.36 20.74zM672.81 514.62a35.44 35.44 0 0 0-4.37 12c-3 21.08-120.48 75.3-120.48 75.3l-49.94 46.68h-13.3s31.62-112.98 78.31-82.87c0 0 46.68-16.57 79.81-49.7a268.45 268.45 0 0 1 29.97-1.41z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M838.65 540.13s-61.74 33.13-67.77 51.2c-2.26 6.78-12.76 16.29-25 25.54-20.45 15.45-45.77 30.18-45.77 30.18l-155.11 6h-57.27a288 288 0 0 1 15-39.76c13.69-29.09 35.92-60.67 63.31-43.04 0 0 46.68-16.57 79.81-49.7 0 0 63.25-7.53 96.38 12s96.42 7.58 96.42 7.58z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M695.55 193.01s-93.48 108.6-133.33 201c-4.1 9.51-8.33 19-12.81 28.29-23.9 49.74-95.81 208-93.3 307L429 735.07s69.27-283.12 97.89-326.79c0 0 126.5-216.86 168.67-237.94z",
    fill: "#635151"
  }), React.createElement("path", {
    d: "M478.29 493.45c-1.64 27.36-3.64 53.4-5.41 74.17-.35 4.28-.71 8.33-1 12.14-1.87 20.86-3.23 34.12-3.23 34.12v.08c-.35 6.52-2.38 16.43-5.66 28.76-1.08 4.08-2.32 8.43-3.66 13-.26.83-.5 1.67-.75 2.51q-1.72 5.78-3.69 12c-.54 1.69-1.08 3.4-1.64 5.14-3 9.38-6.36 19.38-10 29.8-3.25 9.41-6.7 19.16-10.27 29.09l-.59 1.61c-.09.24-.18.5-.27.75h-18.83c.08-.26.15-.51.21-.75 2.88-10.2 5.53-20.19 8-29.89s4.82-19.31 6.91-28.33q1.29-5.53 2.48-10.81c.26-1.14.51-2.27.75-3.39.12-.5.23-1 .33-1.48.54-2.39 1.05-4.74 1.54-7 .2-.84.38-1.69.56-2.51l.45-2.11c1.13-5.27 2.17-10.27 3.12-14.94a1442.837 1442.837 0 0 0 4.6-23.68c2-10.69 3-16.85 3-16.85a3.46 3.46 0 0 0 .11-.42c1.22-4.44 2.35-9 3.39-13.66 6.11-27.08 9.68-57.5 11.63-87.36 5.14-78.4-.81-153-.81-153l13.33-18.24c11.29 22.01 9.58 101.01 5.4 171.25zM662.84 375.19s-27.53 44.49-54.83 101.21q-4 8.36-8 17a738.11 738.11 0 0 0-27.72 68.57c-.77 2.24-1.52 4.49-2.24 6.72-1.36 4.17-2.65 8.33-3.86 12.44-.48 1.61-.95 3.22-1.39 4.82q-1.29 4.56-2.44 9.05c-1.11 4.38-2.12 8.72-3 13 0 0-5.66 17.41-13.33 45-.48 1.78-1 3.58-1.49 5.44-.35 1.28-.71 2.59-1.07 3.92-2.74 10.2-5.69 21.5-8.67 33.64-1 4.16-2 8.4-3.06 12.76-2.06 8.72-4.13 17.8-6.13 27.12 0 .26-.11.5-.15.75h-18.89c0-.26.08-.51.11-.75 1.3-9.94 2.61-19.65 4-29 .95-6.7 1.93-13.24 2.91-19.52 1.72-11.05 3.48-21.38 5.23-30.69.24-1.22.47-2.42.69-3.6v-.14a291.23 291.23 0 0 1 7.59-31.55 72 72 0 0 1 2.71-7.2s2.55-6.54 7-17.54l2.26-5.65c3-7.3 6.52-16.05 10.57-25.84.56-1.37 1.14-2.77 1.73-4.19 8.24-19.83 18.27-43.43 29-67.53 2.88-6.46 5.8-13 8.76-19.41 25.39-55.42 53.07-108.91 70.22-121.15z",
    fill: "#635151"
  }), React.createElement("path", {
    d: "M203.11 131.27s94.12 121.23 138.54 213.84c0 0 103.91 203.8 100.9 322.52l27.1 5.78s-30.12-143.12-61-243.21c-15.85-51.4-46.39-100.47-74.72-146.19-40.78-65.8-103.51-161.66-130.84-175.32zM639.32 737.12a6 6 0 0 0-.9-.2 8.48 8.48 0 0 0-.86-.14c-.35 0-.69-.09-1-.11s-.65 0-1 0H280.45c-.34 0-.71.06-1.05.11.48-.3 1-.6 1.48-.89 8.63-5.11 20.18-9.77 34.09-13.84 27.69-8.1 64.74-13.87 106.52-16.05 4.91-.27 9.89-.47 14.92-.63l6.85-.18c4.47-.09 9-.15 13.55-.15h2.29c17.83 0 35.1.65 51.52 1.85q10.8.79 21.05 1.9a450.62 450.62 0 0 1 60.72 10.36c18.79 4.7 34.14 10.38 44.92 16.76q1.04.58 2.01 1.21z",
    fill: "#635151"
  }), React.createElement("path", {
    d: "M425.99 653.08h-57.23l-155.11-6s-23.39-13.6-43.36-28.37c31.7-28.06 83.61-27.5 96.06-20.57 13.56 7.48 39.16 4.48 39.16 4.48 18.81-42.55 70.14-16.81 103.14 5.84a285.61 285.61 0 0 1 17.34 44.62z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M438.03 635.76s-103.91-93.37-132.52-28.61c0 0-25.6 3-39.15-4.52s-73.79-7.53-103.91 28.61-102.4 72.29-102.4 72.29 73.06 6.28 108.43 18.07c9 3 60.24-1.51 94.87-12s72.3 6.02 72.3 6.02l106.9-43.72z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M442.55 671.9l-106.9 43.72a131.49 131.49 0 0 0-34.11-8.73c-11.72-1.39-25.16-1.25-38.18 2.71-34.64 10.54-85.84 15.06-94.87 12-35.37-11.79-108.43-18.07-108.43-18.07s72.29-36.14 102.4-72.29 90.34-36.14 103.9-28.62 39.15 4.52 39.15 4.52c28.61-64.76 132.52 28.61 132.52 28.61l2.17 17.41z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M745.83 616.88c-20.45 15.45-45.77 30.18-45.77 30.18l-155.11 6h-57.22a288 288 0 0 1 15-39.76c32.23-23.42 89.81-56.34 110-10.69 0 0 25.6 3 39.15-4.52 12.18-6.76 62.12-7.47 93.95 18.79z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M480.2 635.76s103.91-93.37 132.52-28.61c0 0 25.6 3 39.15-4.52s73.79-7.53 103.91 28.61 102.4 72.29 102.4 72.29-73.04 6.28-108.42 18.09c-9 3-60.24-1.51-94.87-12s-72.24 6-72.24 6l-107-43.72z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M858.19 703.53s-73.05 6.28-108.43 18.09c-9 3-60.24-1.51-94.87-12-17.26-5.26-35.25-3.78-49-1a126.47 126.47 0 0 0-23.24 7l-107-43.72 2.73-21.79 1.79-14.35s103.91-93.37 132.52-28.61c0 0 25.6 3 39.15-4.52s73.79-7.53 103.91 28.61 102.44 72.29 102.44 72.29z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M605.92 708.62a126.47 126.47 0 0 0-23.27 7l-107-43.72 2.73-21.79c33.31-4.2 96.67 17.27 96.67 17.27s41.98 23.42 30.87 41.24zM442.55 671.9l-106.9 43.72a131.49 131.49 0 0 0-34.11-8.73 12.34 12.34 0 0 1-.53-1.81c10.87-61.59 103.11-56.35 139.21-51.86z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M602.51 709.31c-1.31 3.51-4.46 6.85-10.1 9.82a58.69 58.69 0 0 1-9.8 4c-12.89 4.05-21.63 8.46-27.48 12.8-.35.26-.66.5-1 .75h-195c-.15-.3-.3-.54-.41-.75-.29-.5-.47-.75-.47-.75-22.83-.71-35.86-6.84-43.24-13.09-8.22-6.93-9.47-14-9.47-14 0-.21.08-.44.12-.65 9.41-50.33 73.67-55.49 116-53.25 4.2.23 8.18.51 11.87.84l2.29.21 4.71.5 2 .23c2.35.27 4.49.56 6.4.83 1.07.14 2 .29 3 .41 3.37.51 5.69.92 6.69 1.1l.56.11a17.58 17.58 0 0 1 2.2-1.49 22.25 22.25 0 0 1 3-1.45c.44-.18.89-.33 1.34-.48a47.11 47.11 0 0 1 12.41-2.18c1.37-.09 2.77-.14 4.22-.15 1.79 0 3.64 0 5.54.08s3.6.18 5.45.33c.33 0 .66 0 1 .08a232.74 232.74 0 0 1 24.49 3.6c8.67 1.7 17.15 3.73 24.65 5.71 15.71 4.14 27.14 8 27.14 8s38.43 21.4 31.89 38.84z",
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 573.12,
    cy: 351.57,
    rx: 42.13,
    ry: 27.11,
    transform: "rotate(-14.25 239.106 770.362)",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M491.73 264.03s60.36-34.41 89.56-6.8c0 0-26.37 50.88-91.45 24.9z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M482.22 264.16s36.18-59.32 75.09-49.28c0 0 1.53 57.28-68 66z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M479.86 262.98s36.19-59.36 75.09-49.28c0 0 1.53 57.28-68 66z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M486.96 278.56l-1-2.36-6.1-14.39s15.79-25.93 37.79-40.59c11.26-7.53 24.13-12.1 37.31-8.69-.01 0 1.53 57.28-68 66.03z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M517.65 221.22c-.86 16.25-8.26 35.95-31.57 55.06l-.11-.07-6.1-14.39s15.78-25.94 37.78-40.6z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M483.71 276.27l-3.36-2.35-11.57-8.05s-.41-30 10.19-54.08c5.52-12.53 14-23.43 27.14-27.61 0 0 31.8 47.67-22.4 92.09z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M480.8 273.95h-.45l-11.57-8.05s-.41-30 10.19-54.08c7.45 14.16 11.14 34.4 1.83 62.13z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M460.26 273.07s-37.72-58.35-11.78-89c0 0 52.27 23.5 30 89.92z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M451.26 276.22s-53.88-43.88-38.61-81.07c0 0 57 6.24 56.21 76.31z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M448.9 276.22s-53.87-43.89-38.65-81.07c0 0 57 6.24 56.21 76.31z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M442.83 283.77s-67.48-16.58-69.65-56.7c0 0 54.15-18.76 83.48 44.88z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M441.65 286.12s-67.48-16.58-69.65-56.7c0 0 54.15-18.76 83.48 44.88z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M438.15 297.62s-68.17 13.45-87.08-22c0 0 41.17-39.86 94.62 5.44z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M436.97 299.94s-68.17 13.45-87.08-22c0 0 41.17-39.86 94.62 5.44z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M448.11 295.29s-49.68 48.58-84.92 29.26c0 0 12.63-55.9 82.16-47.25z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M450.47 297.62s-49.68 48.58-84.92 29.26c0 0 12.63-55.9 82.16-47.25z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M446.33 289.9s8.2 69-28.6 85.14c0 0-36.6-44.1 12.67-93.93z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M449.86 291.07s8.2 69-28.6 85.14c0 0-36.6-44.1 12.67-93.93z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M472.85 294.68s8.2 69-28.6 85.14c0 0-36.6-44.1 12.67-93.93z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M475.21 294.68s8.2 69-28.6 85.14c0 0-36.6-44.1 12.67-93.93z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M466.5 296.07s57.33 39.25 45.25 77.55c0 0-57.29-1.49-62.36-71.38z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M468.85 296.07s57.34 39.25 45.26 77.55c0 0-57.29-1.49-62.36-71.38z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M482.15 286.94s70.85 17.1 78.78 63.68c0 0-52.28 23.55-91.13-49.49z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M484.51 285.76s70.85 17.1 78.78 63.68c0 0-52.28 23.55-91.13-49.49zM460.26 273.07s-37.72-58.35-11.78-89c0 0 52.27 23.5 30 89.92z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M460.26 273.07s-37.72-58.35-11.78-89c0 0 52.27 23.5 30 89.92z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M441.65 286.12s-67.48-16.58-69.65-56.7c0 0 54.15-18.76 83.48 44.88z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M441.65 286.12s-67.48-16.58-69.65-56.7c0 0 54.15-18.76 83.48 44.88z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M450.47 297.62s-49.68 48.58-84.92 29.26c0 0 12.63-55.9 82.16-47.25z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M450.47 297.62s-49.68 48.58-84.92 29.26c0 0 12.63-55.9 82.16-47.25z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M475.21 294.68s8.2 69-28.6 85.14c0 0-36.6-44.1 12.67-93.93z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M475.21 294.68s8.2 69-28.6 85.14c0 0-36.6-44.1 12.67-93.93z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M484.51 285.76s70.85 17.1 78.78 63.68c0 0-52.28 23.55-91.13-49.49z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M484.51 285.76s70.85 17.1 78.78 63.68c0 0-52.28 23.55-91.13-49.49z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M491.3 275.74s72.83 2.66 89.88 46.73c0 0-46.54 33.49-99.15-30.36z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M492.48 269.85s72.83 2.66 89.88 46.73c0 0-46.54 33.49-99.15-30.36z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M492.48 273.39s72.83 2.66 89.88 46.73c0 0-46.54 33.49-99.15-30.36z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M510.51 292.21a42.87 42.87 0 1 1-31.23-52 42.88 42.88 0 0 1 31.23 52z",
    fill: "#f7931a"
  }), React.createElement("path", {
    d: "M487.82 275.72c.85-5.71-3.49-8.77-9.43-10.82l1.93-7.73-4.67-1.17-1.88 7.53c-1.24-.31-2.51-.6-3.77-.89l1.89-7.58-4.7-1.17-1.97 7.73c-1-.23-2-.46-3-.71l-6.49-1.62-1.25 5s3.49.8 3.42.85a2.5 2.5 0 0 1 2.19 2.74l-2.2 8.81a3.9 3.9 0 0 1 .49.16l-.5-.12-3.08 12.34a1.71 1.71 0 0 1-2.16 1.12c0 .07-3.42-.85-3.42-.85l-2.34 5.39 6.12 1.53 3.35.87-1.95 7.82 4.7 1.17 1.93-7.74c1.28.35 2.53.67 3.75 1l-1.92 7.7 4.71 1.17 1.95-7.8c8 1.52 14.06.91 16.6-6.35 2-5.84-.1-9.21-4.32-11.41 3.08-.77 5.4-2.79 6.02-6.97zm-10.75 15.08c-1.45 5.84-11.29 2.68-14.48 1.89l2.58-10.36c3.18.8 13.41 2.38 11.89 8.47zm1.45-15.18c-1.33 5.32-9.52 2.61-12.17 2l2.34-9.4c2.66.64 11.21 1.88 9.83 7.4z",
    fill: "#fff"
  }), React.createElement("ellipse", {
    cx: 316.11,
    cy: 178.27,
    rx: 42.13,
    ry: 27.11,
    transform: "rotate(-14.25 -17.995 597.011)",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M234.72 90.73s60.36-34.41 89.56-6.8c0 0-26.37 50.88-91.45 24.9z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M225.21 90.85s36.18-59.32 75.09-49.28c0 0 1.53 57.28-68 66z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M222.85 89.67s36.18-59.32 75.09-49.28c0 0 1.53 57.28-68 66z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M229.95 105.25l-1-2.36-6.1-14.39s15.8-25.88 37.8-40.59c11.26-7.53 24.13-12.1 37.31-8.69-.02 0 1.52 57.29-68.01 66.03z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M260.65 47.91c-.86 16.25-8.26 35.95-31.57 55.06l-.11-.07-6.1-14.39s15.78-25.89 37.78-40.6z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M226.65 102.97l-3.31-2.35-11.57-8.05s-.41-30 10.19-54.08c5.52-12.53 14-23.43 27.14-27.61 0 0 31.8 47.66-22.45 92.09z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M223.79 100.62h-.45l-11.57-8.05s-.41-30 10.19-54.08c7.45 14.18 11.14 34.43 1.83 62.13z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M203.25 99.76s-37.72-58.35-11.78-89c0 0 52.27 23.5 30 89.92z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M194.25 102.92s-53.87-43.89-38.65-81.07c0 0 57 6.24 56.21 76.31z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M191.89 102.92s-53.87-43.89-38.65-81.07c0 0 57 6.24 56.21 76.31z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M185.82 110.46s-67.48-16.58-69.65-56.7c0 0 54.15-18.76 83.48 44.88z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M184.65 112.82S117.17 96.24 115 56.12c0 0 54.15-18.76 83.48 44.88z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M181.14 124.27s-68.17 13.45-87.08-22c0 0 41.17-39.86 94.62 5.44z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M179.96 126.62s-68.17 13.45-87.08-22c0 0 41.17-39.86 94.62 5.44z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M191.1 121.98s-49.68 48.58-84.92 29.26c0 0 12.63-55.9 82.16-47.25z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M193.46 124.34s-49.68 48.58-84.92 29.28c0 0 12.63-55.9 82.16-47.25z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M189.32 116.62s8.2 69-28.6 85.14c0 0-36.6-44.1 12.67-93.93z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M192.85 117.77s8.2 69-28.6 85.14c0 0-36.6-44.1 12.67-93.93z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M215.84 121.37s8.2 69-28.6 85.14c0 0-36.6-44.1 12.67-93.93z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M218.2 121.37s8.2 69-28.6 85.14c0 0-36.6-44.1 12.67-93.93z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M209.49 122.76s57.33 39.26 45.25 77.58c0 0-57.29-1.49-62.36-71.38z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M211.84 122.76s57.33 39.26 45.25 77.58c0 0-57.29-1.49-62.36-71.38z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M225.14 113.62s70.85 17.1 78.78 63.68c0 0-52.28 23.55-91.13-49.49z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M227.5 112.46s70.85 17.1 78.78 63.68c0 0-52.28 23.55-91.13-49.49zM203.25 99.76s-37.72-58.35-11.78-89c0 0 52.27 23.5 30 89.92z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M203.25 99.76s-37.72-58.35-11.78-89c0 0 52.27 23.5 30 89.92z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M184.65 112.82S117.17 96.24 115 56.12c0 0 54.15-18.76 83.48 44.88z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M184.65 112.82S117.17 96.24 115 56.12c0 0 54.15-18.76 83.48 44.88z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M193.46 124.34s-49.68 48.58-84.92 29.28c0 0 12.63-55.9 82.16-47.25z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M193.46 124.34s-49.68 48.58-84.92 29.28c0 0 12.63-55.9 82.16-47.25z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M218.2 121.37s8.2 69-28.6 85.14c0 0-36.6-44.1 12.67-93.93z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M218.2 121.37s8.2 69-28.6 85.14c0 0-36.6-44.1 12.67-93.93z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M227.5 112.46s70.85 17.1 78.78 63.68c0 0-52.28 23.55-91.13-49.49z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M227.5 112.46s70.85 17.1 78.78 63.68c0 0-52.28 23.55-91.13-49.49z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M234.29 102.44s72.83 2.66 89.88 46.73c0 0-46.54 33.49-99.15-30.36z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M235.47 96.54s72.83 2.66 89.88 46.73c0 0-46.54 33.49-99.15-30.36z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M235.47 100.08s72.83 2.66 89.88 46.73c0 0-46.54 33.49-99.15-30.36z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M253.5 118.9a42.87 42.87 0 1 1-31.23-52 42.88 42.88 0 0 1 31.23 52z",
    fill: "#f7931a"
  }), React.createElement("path", {
    d: "M230.81 102.42c.85-5.71-3.49-8.77-9.43-10.82l1.93-7.73-4.71-1.17-1.88 7.53c-1.24-.31-2.51-.6-3.77-.89l1.89-7.58-4.7-1.17-1.93 7.73c-1-.23-2-.46-3-.71l-6.49-1.62-1.25 5s3.49.8 3.42.85a2.5 2.5 0 0 1 2.19 2.74l-2.2 8.81a3.9 3.9 0 0 1 .49.16l-.5-.12-3.08 12.34a1.71 1.71 0 0 1-2.16 1.12c0 .07-3.42-.85-3.42-.85l-2.34 5.39 6.12 1.53 3.35.87-1.93 7.79 4.7 1.17 1.93-7.74c1.28.35 2.53.67 3.75 1l-1.92 7.7 4.71 1.17 1.95-7.8c8 1.52 14.06.91 16.6-6.35 2-5.84-.1-9.21-4.32-11.41 3.06-.74 5.38-2.74 6-6.94zm-10.76 15.08c-1.45 5.84-11.29 2.68-14.48 1.89l2.58-10.36c3.19.8 13.42 2.37 11.9 8.47zm1.46-15.16c-1.33 5.32-9.52 2.61-12.17 2l2.34-9.4c2.66.61 11.21 1.85 9.83 7.39z",
    fill: "#fff"
  }), React.createElement("ellipse", {
    cx: 812.47,
    cy: 243.13,
    rx: 42.13,
    ry: 27.11,
    transform: "rotate(-40.31 661.204 362.87)",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M719.85 143.4s39.12-57.43 77.47-45.44c0 0-1.35 57.29-71.22 62.53z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M711.37 147.69s6.45-69.19 45.82-77.25c0 0 26.53 50.79-32.08 89.18z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M708.73 147.62s6.45-69.19 45.82-77.25c0 0 26.53 50.79-32.08 89.18z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M721.96 158.55l-1.94-1.68-11.8-10.25s2.83-30.24 16.11-53.06c6.81-11.71 16.37-21.47 29.71-24.19 0-.01 26.53 50.78-32.08 89.18z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M724.33 93.56c6.36 15 8.36 35.92-4.18 63.33h-.13l-11.8-10.27s2.83-30.25 16.11-53.06z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M718.03 157.92l-4-.63-13.93-2.15s-13.56-26.81-14.6-53.06c-.55-13.68 2.32-27.21 12.26-36.72-.05-.01 49.45 28.85 20.27 92.56z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M714.39 157.11l-.41.18-13.93-2.15s-13.56-26.81-14.6-53.06c12.92 9.47 25.13 26.03 28.94 55.03z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M695.56 165.34s-59.52-35.86-49.69-74.82c0 0 57.28-1.85 66.4 67.63z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M688.85 172.13s-67.67-15.76-70.33-55.86c0 0 53.92-19.41 84 43.87z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M686.73 173.16s-67.67-15.76-70.33-55.86c0 0 53.92-19.41 84 43.87z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M684.59 182.62s-67.9 14.74-87.48-20.35c0 0 40.41-40.63 94.71 3.65z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M684.57 185.24s-67.9 14.74-87.48-20.35c0 0 40.41-40.63 94.71 3.65z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M686.45 197.07s-55.33 42-87.89 18.48c0 0 19.48-53.89 87.4-36.67z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M686.43 199.71s-55.33 42-87.89 18.48c0 0 19.48-53.89 87.4-36.67z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M694.4 190.62s-23.3 65.46-63.44 63.58c0 0-13.2-55.76 53.07-78.53z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M697.55 191.72s-23.3 65.46-63.44 63.58c0 0-13.2-55.76 53.07-78.53z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M690.43 186.62s37.67 58.39 11.7 89c0 0-52.25-23.54-29.87-89.95z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M694.12 186.08s37.67 58.39 11.7 89c0 0-52.25-23.54-29.87-89.95z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M716.36 179.22s37.67 58.39 11.7 89c0 0-52.25-23.54-29.87-89.95z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M718.47 178.19s37.67 58.39 11.7 89c0 0-52.25-23.54-29.87-89.95z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M711.26 183.26s68.75 10.09 74.73 49.82c0 0-52.12 23.82-87.37-36.74z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M713.37 182.23s68.75 10.09 74.73 49.82c0 0-52.12 23.82-87.37-36.74z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M721.31 168.19s71.16-15.75 98.74 22.61c0 0-36.62 44.12-103.6-4.44z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M722.91 166.1s71.16-15.75 98.74 22.61c0 0-36.62 44.12-103.6-4.44zM695.56 165.34s-59.52-35.86-49.69-74.82c0 0 57.28-1.85 66.4 67.63z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M695.56 165.34s-59.52-35.86-49.69-74.82c0 0 57.28-1.85 66.4 67.63z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M684.57 185.24s-67.9 14.74-87.48-20.35c0 0 40.41-40.63 94.71 3.65z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M684.57 185.24s-67.9 14.74-87.48-20.35c0 0 40.41-40.63 94.71 3.65z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M697.55 191.72s-23.3 65.46-63.44 63.58c0 0-13.2-55.76 53.07-78.53z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M697.55 191.72s-23.3 65.46-63.44 63.58c0 0-13.2-55.76 53.07-78.53z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M718.47 178.19s37.67 58.39 11.7 89c0 0-52.25-23.54-29.87-89.95z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M718.47 178.19s37.67 58.39 11.7 89c0 0-52.25-23.54-29.87-89.95z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M722.91 166.1s71.16-15.75 98.74 22.61c0 0-36.62 44.12-103.6-4.44z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M722.91 166.1s71.16-15.75 98.74 22.61c0 0-36.62 44.12-103.6-4.44z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M724.65 154.11s66.6-29.6 101.27 2.51c0 0-27.11 50.52-102.41 16.27z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M723.08 148.3s66.6-29.6 101.27 2.51c0 0-27.11 50.52-102.41 16.27z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M724.65 151.48s66.6-29.6 101.27 2.51c0 0-27.11 50.52-102.41 16.27z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M749.1 160.47a42.87 42.87 0 1 1-50.89-33 42.88 42.88 0 0 1 50.89 33z",
    fill: "#f7931a"
  }), React.createElement("path", {
    d: "M721.48 155.62c-1.74-5.5-7-6.35-13.23-5.58l-1.66-7.79-4.74 1 1.62 7.59c-1.25.27-2.52.56-3.78.86l-1.63-7.64-4.74 1 1.66 7.79c-1 .24-2 .47-3 .69l-6.54 1.39 1.08 5.07s3.49-.81 3.44-.74a2.5 2.5 0 0 1 3.17 1.5l1.9 8.88a3.9 3.9 0 0 1 .51-.07l-.5.11 2.61 12.42a1.71 1.71 0 0 1-1.45 2c.07 0-3.45.74-3.45.74l.27 5.87 6.17-1.32 3.46-.77 1.68 7.88 4.74-1-1.66-7.8c1.31-.25 2.57-.51 3.8-.77l1.66 7.76 4.74-1-1.68-7.87c7.88-2.16 13-5.36 12.12-13-.73-6.15-4.14-8.23-8.9-8.35 2.41-1.99 3.61-4.85 2.33-8.85zm-3 18.27c1.26 5.89-9 7.37-12.18 8.06l-2.23-10.44c3.17-.68 13.06-3.76 14.37 2.38zm-5.39-14.27c1.14 5.36-7.4 6.53-10.08 7.1l-2-9.47c2.64-.56 10.88-3.21 12.08 2.37z",
    fill: "#fff"
  }), React.createElement("ellipse", {
    cx: 771.13,
    cy: 431.63,
    rx: 42.13,
    ry: 27.11,
    transform: "rotate(-39.4 617.664 555.25)",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M678.99 332.23s40-56.81 78.18-44.22c0 0-2.25 57.26-72.2 61.4z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M670.44 336.39s7.54-69.08 47-76.52c0 0 25.73 51.2-33.48 88.67z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M667.8 336.32s7.54-69.08 47-76.52c0 0 25.73 51.2-33.48 88.67z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M680.85 347.41l-1.91-1.71-11.64-10.44s3.3-30.19 16.94-52.8c7-11.6 16.7-21.21 30.08-23.72.01 0 25.74 51.2-33.47 88.67z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M684.25 282.46c6.13 15.07 7.8 36.05-5.18 63.26h-.13l-11.64-10.44s3.35-30.21 16.95-52.82z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M676.93 346.72l-4-.7-13.93-2.4s-13.14-27-13.76-53.28c-.33-13.69 2.74-27.17 12.83-36.53 0 .03 49.04 29.67 18.86 92.91z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M673.31 345.86l-.42.17-13.89-2.41s-13.14-27-13.76-53.28c12.77 9.7 24.72 26.46 28.07 55.52z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M654.35 353.79S595.4 317 605.84 278.2c0 0 57.3-.94 65.33 68.66z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M647.54 360.47s-67.42-16.83-69.44-57c0 0 54.22-18.56 83.31 45.19z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M645.4 361.47s-67.42-16.83-69.44-57c0 0 54.22-18.56 83.31 45.19z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M643.11 370.88s-68.13 13.67-87.15-21.73c0 0 41-40 94.64 5.15z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M643.04 373.51s-68.13 13.67-87.15-21.73c0 0 41-40 94.64 5.15z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M644.75 385.37s-56 41.15-88.17 17.09c0 0 20.32-53.58 88-35.29z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M644.65 388.01s-56 41.15-88.17 17.09c0 0 20.32-53.58 88-35.29z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M652.79 379.06s-24.33 65.09-64.43 62.56c0 0-12.32-56 54.3-77.69z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M655.92 380.19s-24.33 65.09-64.43 62.57c0 0-12.32-56 54.3-77.69z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M648.88 374.94s36.75 59 10.3 89.22c0 0-51.87-24.36-28.45-90.41z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M652.59 374.5s36.75 59 10.3 89.22c0 0-51.87-24.36-28.45-90.41z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M674.93 367.99s36.75 59 10.3 89.22c0 0-51.87-24.36-28.45-90.41z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M677.06 366.99s36.75 59 10.3 89.22c0 0-51.87-24.36-28.45-90.41z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M669.76 371.95s68.58 11.17 73.93 51c0 0-52.49 23-86.78-38.11z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M671.9 370.95s68.58 11.17 73.93 51c0 0-52.49 23-86.78-38.11z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M680.05 357.04s71.4-14.63 98.38 24.16c0 0-37.31 43.54-103.52-6.07z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M681.65 354.97s71.4-14.63 98.38 24.16c0 0-37.31 43.54-103.52-6.07zM654.35 353.79S595.4 317 605.84 278.2c0 0 57.3-.94 65.33 68.66z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M654.35 353.79S595.4 317 605.84 278.2c0 0 57.3-.94 65.33 68.66z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M643.04 373.51s-68.13 13.67-87.15-21.73c0 0 41-40 94.64 5.15z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M643.04 373.51s-68.13 13.67-87.15-21.73c0 0 41-40 94.64 5.15z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M655.92 380.19s-24.33 65.09-64.43 62.57c0 0-12.32-56 54.3-77.69z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M655.92 380.19s-24.33 65.09-64.43 62.57c0 0-12.32-56 54.3-77.69z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M677.06 366.99s36.75 59 10.3 89.22c0 0-51.87-24.36-28.45-90.41z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M677.06 366.99s36.75 59 10.3 89.22c0 0-51.87-24.36-28.45-90.41z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M681.65 354.97s71.4-14.63 98.38 24.16c0 0-37.31 43.54-103.52-6.07z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M681.65 354.97s71.4-14.63 98.38 24.16c0 0-37.31 43.54-103.52-6.07z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M683.58 343.02s67.07-28.55 101.21 4.1c0 0-27.9 50.09-102.65 14.65z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M682.14 337.18s67.06-28.56 101.21 4.1c0 0-27.9 50.09-102.65 14.65z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M683.65 340.38s67.06-28.54 101.22 4.11c0 0-27.9 50.09-102.65 14.65z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M707.96 349.76a42.87 42.87 0 1 1-50.36-33.78 42.88 42.88 0 0 1 50.36 33.78z",
    fill: "#f7931a"
  }), React.createElement("path", {
    d: "M680.42 344.48c-1.65-5.53-6.89-6.46-13.14-5.79l-1.54-7.82-4.76.94 1.5 7.61c-1.25.25-2.52.52-3.79.8l-1.51-7.66-4.76.94 1.54 7.82c-1 .22-2 .44-3 .64l-6.56 1.29 1 5.08s3.5-.76 3.45-.68a2.5 2.5 0 0 1 3.15 1.55l1.76 8.91a3.9 3.9 0 0 1 .51-.07l-.5.1 2.43 12.48a1.71 1.71 0 0 1-1.48 1.93c.07 0-3.46.68-3.46.68l.17 5.87 6.19-1.22 3.4-.64 1.56 7.91 4.75-.94-1.54-7.82c1.31-.23 2.58-.47 3.81-.71l1.53 7.79 4.76-.94-1.54-7.91c7.91-2 13.11-5.15 12.33-12.8-.63-6.16-4-8.3-8.76-8.49 2.48-1.99 3.73-4.81 2.5-8.85zm-3.32 18.22c1.17 5.91-9.08 7.23-12.31 7.87l-2.06-10.48c3.22-.64 13.15-3.56 14.36 2.61zm-5.13-14.34c1.06 5.38-7.5 6.41-10.19 6.94l-1.87-9.5c2.68-.54 10.95-3.05 12.06 2.55z",
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 908.36,
    cy: 75.19,
    r: 49.74,
    fill: "#ffdf9c"
  }), React.createElement("path", {
    d: "M210.24 546.16l4.67 13.3-3.59 22.33s-5.42 17.81-4.88 26.45 0 20.51 0 20.51-13 23.75-2.17 33.47c2.52 2.26 4.63 1.8 6.38-.22a56 56 0 0 0 5.44 2.64L207 700l-8.68 17.27s-18.44 15.65-25.49 48.58c0 0-7 21.94-11.51 28.48a9 9 0 0 1-.67.88 37 37 0 0 1-1.92-3.46l-8.14 21.59s16.27 9.18 27.66 13 24.41-.54 28.2-5.4-7.59-10.26-15.73-13.49c-3.95-1.57-6.1-5.3-7.28-8.73a49.09 49.09 0 0 1-.23-3.53c-.17-6.13.77-14.4 5.88-20.67 9.22-11.34 23.32-39.4 23.32-39.4S226.52 720 229.77 714l19.53-32.6c10.83 12.31 21.7 41.27 21.7 41.27l4.34 26.45s14.1 37.78 18.44 41.56c.12.11.24.22.36.35l.11.12.26.3.11.13.34.45.08.12.26.39.12.2.23.39.11.18.31.57.11.21.21.43.12.25.22.47.09.2.28.66.11.26.19.48.11.27.24.62.06.16.25.69.09.26.19.54.08.23.25.76v.1l.21.67.07.23.19.61v.16l.22.76v.15l.17.6.06.22.16.57v.16l.17.65.08.31.08.31.1.38v.1c.13.5.24 1 .34 1.4l.13.54.06.25v.07a20.1 20.1 0 0 1-2.26-1.74 61.69 61.69 0 0 1 0 10.8c-.54 5.4 4.88 13 4.88 13s48.81-11.88 51.52-20-8.68-7-11.93-5.94-19.52-2.16-21.69-5.94a10.44 10.44 0 0 0-1.46-1.93 3.09 3.09 0 0 0-3.76-.62l-.12-.14-.14-.17-.1-.12-.17-.23c-.12-.16-.24-.34-.36-.52l-.13-.2q-.33-.51-.66-1.11v-.08c-3.46-6.32-7.18-19.21-8-22.27v-.07l-.07-.25V770.73l-12.47-40.48c3.8-14.57 0-21.59 0-21.59l-7.05-32.93-4-14.91c.12-.13.18-.2.18-.2-3.24-9.07-5.79-28.31-7.37-43.18q-.15-1.45-.3-2.83l12 5.53s16.27 24.83 26.58 13-20.61-22.13-20.61-22.13L273.74 598v-.57l-2.17-16.19s-6-19.43-3.25-32.39c2.31-11-5.22-15-7.5-16a7.25 7.25 0 0 0-1.1-.33c-3-.7-6.29-3.73-9.11-7a35.72 35.72 0 0 0-8.45-7.09 8.31 8.31 0 0 0 3.55-5.26c.45-2.49-.4-5-1.17-7.41a66.15 66.15 0 0 1 3.84-7.87h.09l.66-1.09a23.52 23.52 0 0 0 20.81-23.31 23.28 23.28 0 0 0-2.94-11.25c2.43-.84 4.76-1.91 3.88-4.4-.59-1.69-2.18-2.79-3.41-4.08-3.27-3.44-4.26-8.6-7.68-11.88a11.68 11.68 0 0 0-3.38-2.24c-3.47-2-7.92-2.22-11.93-1.48-5 .91-9.6 3.1-14.45 4.5-4.27 1.24-8.73 1.87-12.81 3.61-7 3-12.34 9-15.56 15.83-2.84 6-4.17 12.73-7.28 18.63s-8.82 11.23-15.52 11c-1.73-.06-3.53-.48-5.15.13a6.28 6.28 0 0 0-3 2.73c-3.68 6-1.31 14.05-4.24 20.44-2.17 4.75-6.86 7.75-10.7 11.31s-7.15 8.87-5.33 13.76a10 10 0 0 0 5.55 5.45A14.11 14.11 0 0 0 160 547c3.64.74 7.41.29 11.11 0 10-.71 21-.33 29-6.44 3.28-2.52 5.81-6 8.43-9.27a69.29 69.29 0 0 0 1.7 14.87zm14.44 33.94c.81 1.35 1.64 2.68 2.5 4 8 12.24-2.84 29-2.84 29a29.32 29.32 0 0 0-6.27 7.13c.14-5.15.74-11 2.48-15.23 2.7-6.53 3.75-18.52 4.14-24.9z",
    transform: "translate(-113.35 -69.38)",
    fill: "url(#prefix__b)"
  }), React.createElement("path", {
    d: "M103.18 487.27l-4.24 26.35s-5.3 17.4-4.77 25.83 0 20 0 20-12.71 23.2-2.12 32.69 13.77-30.05 13.77-30.05-1.59-16.87 2.12-25.83 4.24-28.47 4.24-28.47z",
    fill: "#ffcdd3"
  }), React.createElement("path", {
    d: "M103.18 487.27l-4.24 26.35s-5.3 17.4-4.77 25.83 0 20 0 20-12.71 23.2-2.12 32.69 13.77-30.05 13.77-30.05-1.59-16.87 2.12-25.83 4.24-28.47 4.24-28.47z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M165.25 577.91l7.33 27.45 6.89 32.16s3.71 6.85 0 21.09l12.18 39.54s6.89 25.31 11.12 25.83-4.24 20-4.24 20l-11.65-6.85s-3.23-15.78-7.42-19.51-18-40.6-18-40.6l-4.24-25.83s-13.24-35.32-24.9-43.76-15.36-22.14-15.36-22.14z",
    fill: "#ffcdd3"
  }), React.createElement("path", {
    d: "M116.95 585.33s3.71 13.71 15.36 22.14 24.9 43.76 24.9 43.76l4.24 25.83s13.77 36.9 18 40.6c3.11 2.71 5.65 12 6.78 16.68.41 1.71.64 2.83.64 2.83l11.65 6.85s8.48-19.51 4.24-20c-.66-.08-1.38-.76-2.13-1.85-4.08-5.92-9-24-9-24l-12.17-39.55c3.71-14.23 0-21.09 0-21.09l-6.89-32.16-7.33-27.45z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M49.15 722.4l4.24 10 19.07-2.11a43.79 43.79 0 0 1-1-8.28c-.17-6 .75-14.06 5.74-20.19 9-11.07 22.78-38.49 22.78-38.49s13.77-14.76 17-20.56l26.52-44.27-.83-4 7.15-6.59h-44.5l-10.59 41.12-8.48 16.87s-18 15.29-24.9 47.45c0 0-6.87 21.43-11.25 27.82a7.69 7.69 0 0 1-.95 1.23z",
    fill: "#ffcdd3"
  }), React.createElement("path", {
    d: "M186.24 734.33c.41 1.71.64 2.83.64 2.83l11.65 6.85s8.48-19.51 4.24-20c-.66-.08-1.38-.76-2.13-1.85a3 3 0 0 0-1.36 3.28 8.15 8.15 0 0 0 .84 2.25c1.59 2.64-5.3 6.85-5.3 6.85-2.32 2.96-6.08 1.39-8.58-.21z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M199.81 726.48a3.08 3.08 0 0 1 5.24-2.8 10.2 10.2 0 0 1 1.42 1.89c2.12 3.69 18 6.85 21.19 5.8s14.3-2.11 11.65 5.8-50.32 19.51-50.32 19.51-5.3-7.38-4.77-12.65a60.25 60.25 0 0 0 0-10.54s7.43 6.84 11.13 2.13c0 0 6.89-4.22 5.3-6.85a8.15 8.15 0 0 1-.84-2.29z",
    fill: "#dce6f2"
  }), React.createElement("path", {
    d: "M49.15 722.4l4.24 10 19.07-2.11a43.79 43.79 0 0 1-1-8.28 2.61 2.61 0 0 0-4.25-.61c-1 1.05-2 2.17-2.72 3.08-2.12 2.64-9 1.05-9 1.05-1.79.59-3.9-2-5.42-4.34a7.69 7.69 0 0 1-.92 1.21z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M66.65 722.48a2.61 2.61 0 0 1 4.43 1.09c1 3.75 3.08 8.59 7.68 10.43 7.95 3.16 19.07 8.44 15.36 13.18s-16.42 9-27.55 5.27-27-12.65-27-12.65l7.95-21.09s4.24 9 7.42 7.91c0 0 6.89 1.58 9-1.05.78-.95 1.77-2.03 2.71-3.09z",
    fill: "#dce6f2"
  }), React.createElement("path", {
    d: "M138.65 426.11s-12.71 17.4-9.54 29.52-25.43-7.91-25.43-7.91a42 42 0 0 0 12.18-34.8z",
    fill: "#ffcdd3"
  }), React.createElement("path", {
    d: "M96.82 591.13c21.19 12.65 46.62 7.38 46.62 7.38l-.53-3.69 1.1.11c20.25 1.78 24.85-4.32 24.85-4.32-3.17-8.86-5.65-27.65-7.2-42.18-.22-2.09-.42-4.09-.61-6-.42-4.23-.73-7.8-.93-10.21-.17-2.12-.26-3.34-.26-3.34l-2.12-15.82s-5.83-19-3.18-31.63c2.26-10.78-5.09-14.67-7.32-15.59a7.08 7.08 0 0 0-1.08-.32c-2.91-.69-6.14-3.64-8.89-6.81a35.72 35.72 0 0 0-14.86-10.09c-2.66-1-4.93-2-4.93-2-3.71-4.22-13.77-1.58-13.77-1.58-12.18 7.91-5.83 33.74-5.83 33.74l5.06 14.4a106.81 106.81 0 0 0 11.48 22.66c7.79 12-2.78 28.31-2.78 28.31-16.41 13.23-14.82 46.98-14.82 46.98z",
    fill: "#ff8aa1"
  }), React.createElement("path", {
    d: "M142.12 566.62l1.9 28.31c20.25 1.78 24.85-4.32 24.85-4.32-3.17-8.86-5.65-27.65-7.2-42.18-.22-2.09-.42-4.09-.61-6z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M108.48 492.54s9.54 17.93 12.71 25.83 3.18 5.27 4.77 7.91 18.54 14.23 18.54 14.23l17.15 7.91c-.73-6.81-1.25-12.69-1.54-16.16l-16.16-10.72s-11.12-6.85-11.65-15.82-7.42-25.31-7.42-25.31-13.77-14.76-19.6-7.91 3.2 20.04 3.2 20.04z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M124.9 477.78s6.89 16.34 7.42 25.31 11.65 15.82 11.65 15.82l35 23.2s30.19 10 20.13 21.62-26-12.65-26-12.65l-28.61-13.18s-17-11.6-18.54-14.23-1.59 0-4.77-7.91-12.71-25.83-12.71-25.83-9-13.18-3.18-20 19.61 7.85 19.61 7.85z",
    fill: "#ffcdd3"
  }), React.createElement("path", {
    d: "M129.14 484.62s-10.59-7.91-12.71-10.54c-.94-1.16-2.39-1-3.72-.44a16.76 16.76 0 0 1-7.87 1.29c-2.32-.2-4.57-.07-4.3 1.25.53 2.64-1.59-13.71-1.59-13.71l9-3.16 11.7 6.31z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M129.14 483.62s-10.59-7.91-12.71-10.54c-.94-1.16-2.39-1-3.72-.44a16.76 16.76 0 0 1-7.87 1.29c-2.32-.2-4.57-.07-4.3 1.25.53 2.64-1.59-13.71-1.59-13.71l9-3.16 11.7 6.31z",
    fill: "#ff8aa1"
  }), React.createElement("path", {
    d: "M154.08 484.62a13.05 13.05 0 0 1-12-.79M119.34 414.25c.4-3.15-3.52 3.39-4-.26l22.78 13.18s-1.3 1.78-3 4.6a23.37 23.37 0 0 1-2.6.15c-6.79-.01-8.96-12.95-13.18-17.67z",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 133.11,
    cy: 407.92,
    rx: 23.04,
    ry: 22.93,
    fill: "#ffcdd3"
  }), React.createElement("path", {
    d: "M143.45 408.32a11.7 11.7 0 0 1-.83 4.24c-1 1.79-3 2.6-4.78 3.67-7 4.32-9.13 14-6.88 21.95.79 2.8 2 5.65 1.53 8.51-.89 4.92-6.53 7.48-11.54 7.91s-10.25-.37-14.94 1.45c-7.87 3.05-11.33 12.24-18 17.37-7.78 6-18.49 5.6-28.29 6.29-3.62.26-7.3.69-10.86 0s-7.07-2.86-8.33-6.25c-1.77-4.78 1.46-10 5.21-13.44s8.33-6.4 10.45-11c2.86-6.24.55-14.12 4.14-20a6.14 6.14 0 0 1 2.92-2.67c1.58-.59 3.34-.18 5-.12 6.54.22 12.12-5 15.16-10.74s4.33-12.3 7.11-18.2c3.14-6.68 8.38-12.57 15.2-15.46 4-1.7 8.35-2.32 12.51-3.53 4.74-1.37 9.26-3.51 14.11-4.4s10.35-.3 13.89 3.11c3.34 3.21 4.31 8.25 7.5 11.61 1.21 1.27 2.75 2.34 3.34 4 1.38 3.9-5.3 4.23-7.52 5.8a14.56 14.56 0 0 0-6.1 9.9z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M142.39 407.79a11.7 11.7 0 0 1-.83 4.24c-1 1.79-3 2.6-4.78 3.67-7 4.32-9.13 14-6.88 21.95.79 2.8 2 5.65 1.53 8.51-.89 4.92-6.53 7.48-11.54 7.91s-10.25-.37-14.94 1.45c-7.87 3.05-11.33 12.24-18 17.37-7.78 6-18.49 5.6-28.29 6.29-3.62.26-7.3.69-10.86 0s-7.07-2.86-8.33-6.25c-1.77-4.78 1.46-10 5.21-13.44s8.33-6.4 10.45-11c2.86-6.24.55-14.12 4.14-20a6.14 6.14 0 0 1 2.92-2.67c1.58-.59 3.34-.18 5-.12 6.54.22 12.12-5 15.16-10.74s4.33-12.3 7.11-18.2c3.14-6.68 8.38-12.57 15.2-15.46 4-1.7 8.35-2.32 12.51-3.53 4.74-1.37 9.26-3.51 14.11-4.4s10.35-.3 13.89 3.11c3.34 3.21 4.31 8.25 7.5 11.61 1.21 1.27 2.75 2.34 3.34 4 1.38 3.9-5.3 4.23-7.52 5.8a14.56 14.56 0 0 0-6.1 9.9zM211.09 327.62c3.44 12.47 15.37 20.05 15.37 20.05s6.37-12.63 2.93-25.1-15.37-20.05-15.37-20.05-6.37 12.67-2.93 25.1zM275.4 397.09c-3.7 12.39 2.4 25.15 2.4 25.15s12.09-7.33 15.79-19.72-2.4-25.15-2.4-25.15-12.09 7.33-15.79 19.72zM739.26 476.8c-9.08 9.21-9.67 23.34-9.67 23.34s14.12-.8 23.2-10 9.67-23.34 9.67-23.34-14.12.82-23.2 10z",
    fill: primaryColor
  }));
};
UndrawCryptoFlowers.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawCryptoFlowers;